import React from "react"

import imgNumberPoints from "./../../../assets/images/packaging-delivery/performance/puntos.webp"

import imgSobreEmpaques from "./../../../assets/images/packaging-delivery/performance/sobre_empaques.webp"
import imgServientrega from "./../../../assets/images/packaging-delivery/performance/servientrega.webp"
import imgFabrica from "./../../../assets/images/packaging-delivery/performance/fabrica.webp"
import imgClasificacion from "./../../../assets/images/packaging-delivery/performance/clasificacion.webp"
import imgEngranajes from "./../../../assets/images/packaging-delivery/performance/engranajes.webp"
import imgParticulas from "./../../../assets/images/packaging-delivery/performance/particulas.webp"
import imgDeslizadero from "./../../../assets/images/packaging-delivery/performance/deslizadero.webp"
import imgBanca from "./../../../assets/images/packaging-delivery/performance/banca.webp"
import imgLibros from "./../../../assets/images/packaging-delivery/performance/libros.webp"
import imgPlanetaNosotras from "./../../../assets/images/packaging-delivery/performance/planeta_nosotras.webp"

import "./packaging-delivery-section-4.scss"

function PackagingDeliverySection4() {
  const Separador = color => {
    return (
      <img
        src={require(`./../../../assets/images/packaging-delivery/performance/corazon_${color}.webp`)}
        alt="separador: corazon"
      />
    )
  }

  return (
    <div className="f-packaging-delivery-section-4">
      <div className="f-packaging-delivery-section-4__container">
        <h2 className="f-packaging-delivery-section-4__title">
          Así le das una{" "}
          <span className="f-packaging-delivery-section-4__title__yellow-fill">
            nueva vida
          </span>{" "}
          a tus{" "}
          <span className="f-packaging-delivery-section-4__title__bold">
            empaques Nosotras
          </span>{" "}
          y{" "}
          <span className="f-packaging-delivery-section-4__title__bold f-packaging-delivery-section-4__title__pink">
            ganas puntos
          </span>{" "}
          por ayudar:
        </h2>
        <div className="f-packaging-delivery-section-4__round-container">
          <p className="f-packaging-delivery-section-4__round-container__paragraph-1">
            <span className="f-packaging-delivery-section-4__round-container__paragraph-1__36">
              ¡Recuerda!
            </span>{" "}
            <br />
            <span className="f-packaging-delivery-section-4__round-container__paragraph-1__yellow">
              cada sobre con <b className="number-bold">10</b> empaques
              Nosotras,
            </span>{" "}
            te dará
          </p>
          <p className="f-packaging-delivery-section-4__round-container__paragraph-2">
            <img
              className="f-packaging-delivery-section-4__round-container__paragraph-2__img"
              src={imgNumberPoints}
              alt="20 Puntos"
            />
            para redimir en lo que quieras
          </p>
          <p className="f-packaging-delivery-section-4__round-container__paragraph-3">
            y cada empaque adicional te da{" "}
            <span className="f-packaging-delivery-section-4__round-container__paragraph-3__yellow">
              <b className="number-bold">2</b> puntos más.
            </span>
          </p>
        </div>
        <div className="f-packaging-delivery-section-4__stepper">
          <div className="f-packaging-delivery-section-4__stepper__step-1">
            <div className="f-packaging-delivery-section-4__stepper__step-1__images">
              <img
                src={imgSobreEmpaques}
                alt="Sobre con empaques"
                className="f-packaging-delivery-section-4__stepper__step-1__images__item"
              />
              {Separador("rosa")}
              <img
                src={imgServientrega}
                alt="Servientrega"
                className="f-packaging-delivery-section-4__stepper__step-1__images__item"
              />
            </div>
            <p className="f-packaging-delivery-section-4__stepper__step-1__description">
              Después de que tú llevas tu sobre con mínimo{" "}
              <b>10 empaques Nosotras</b> a Servientrega...
            </p>
          </div>
          <div className="f-packaging-delivery-section-4__stepper__step-2">
            <div className="f-packaging-delivery-section-4__stepper__step-2__images">
              <div className="f-packaging-delivery-section-4__stepper__step-2__images__item">
                <img src={imgFabrica} alt="Sobre con empaques" />
                <p>Nosotras llevamos los empaques a una planta recicladora</p>
              </div>
              {Separador("lila")}
              <div className="f-packaging-delivery-section-4__stepper__step-2__images__item">
                <img src={imgClasificacion} alt="Servientrega" />
                <p>Donde son clasificados</p>
              </div>{" "}
              {Separador("lila")}
              <div className="f-packaging-delivery-section-4__stepper__step-2__images__item">
                <img src={imgEngranajes} alt="Servientrega" />
                <p>y procesados</p>
              </div>
            </div>
          </div>
          <div className="f-packaging-delivery-section-4__stepper__step-3">
            <div className="f-packaging-delivery-section-4__stepper__step-3__images">
              <div className="f-packaging-delivery-section-4__stepper__step-3__images__item">
                <img src={imgParticulas} alt="Sobre con empaques" />
                <p>
                  Para convertirse en pequeñas particulas plásticas o de cartón
                </p>
              </div>
            </div>
          </div>
          <div className="f-packaging-delivery-section-4__stepper__step-4">
            <div className="f-packaging-delivery-section-4__stepper__step-4__images">
              <div className="f-packaging-delivery-section-4__stepper__step-4__images__item">
                <img src={imgDeslizadero} alt="Sobre con empaques" />
              </div>
              {Separador("azul")}
              <div className="f-packaging-delivery-section-4__stepper__step-4__images__item">
                <img src={imgBanca} alt="Servientrega" />
              </div>{" "}
              {Separador("azul")}
              <div className="f-packaging-delivery-section-4__stepper__step-4__images__item">
                <img src={imgLibros} alt="Servientrega" />
              </div>
            </div>
            <p className="f-packaging-delivery-section-4__stepper__step-4__description">
              Que se transformarán en muebles, parques infantiles, cuadernos,
              mangueras, comederos y mucho más.
            </p>
          </div>
        </div>
        <div className="f-packaging-delivery-section-4__nosotras-planet">
          <img src={imgPlanetaNosotras} alt="Planeta nosotras" />
          <p>
            <span>Así, damos </span> <span>Loving</span> <span>a nuestro</span>{" "}
            <span>planeta</span> Y tú <span className="number-bold">¿</span>ya
            estás lista para participar?
          </p>
        </div>
      </div>
    </div>
  )
}

export default PackagingDeliverySection4
